<template>
    <div class="clearfix userCenterView userInfo">
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">基本信息</div>
            <div class="content" style="flex-direction: column">
                <div class="left mr30" style="margin-left: 112px;margin-top:35px;">
                    <div class="portrait pr" style="width: 100px;">
                        <div style="position:absolute;right: 124px;width: 100px;text-align:right;font-size: 14px;color: #606266;line-height: 100px;">头像:</div>
                        <section class="p-user-data">
                            <img :src="imgSrc" @click="showCutter=true" style="width: 100px;border-radius: 100px;cursor: pointer;">
                            <Cutter v-if="showCutter" @cancel="showCutter = false" return-type="file" @enter="uploadAvatar"></Cutter>
                        </section>
                        <!-- <div style="text-align: center;margin-top: 15px;"> {{ userInfo.username }} </div> -->

                    </div>
                    <!-- <div class="btn colorBlue csp tc f14 mt15" @click="showCutter=true" v-loading.fullscreen.lock="fullscreenLoading">修改</div> -->

                </div>
                <div class="right mt30">
                    <el-form :model="userInfo"  :rules="rules" ref="userInfo" label-width="100px" class="demo-ruleForm infoForm">
                        <el-form-item label="姓名:" prop="username">
                            <el-input v-model="userInfo.real_name" auto-complete="off" :readonly="!edit" />
                        </el-form-item>
                        <el-form-item label="昵称:" prop="nickname">
                            <el-input v-model="userInfo.nickname" auto-complete="off" :readonly="!edit" />
                        </el-form-item>
                        <el-form-item label="性别:" prop="sex">
                            <el-select v-model="userInfo.sex" auto-complete="off" style="width:270px;" :disabled="!edit">
                                <el-option :value="0" label="保密" :key="0"></el-option>
                                <el-option :value="1" label="男" :key="1"></el-option>
                                <el-option :value="2" :key="2">女</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号码:" prop="mobile">
                            <span style="margin-left:15px;">{{ userInfo.mobile }}</span> <router-link to="/userCenter/securitySetting" class="mobileChange">修改</router-link>
                        </el-form-item>
                        <el-form-item label="邮箱:" prop="email">
                            <span style="margin-left:15px;">{{ userInfo.email }}</span> <router-link to="/userCenter/securitySetting" class="emailChange">修改</router-link>
                        </el-form-item>
                        <el-form-item label="所在地区:">
                            <el-col :span="8" :disabled="!edit" :class="edit?'edit':'disable'">
                                <el-form-item prop="province" style="border-bottom: 0;padding:0">
                                    <el-select v-model="userInfo.province" style="width:230px" @change="getArea(2,userInfo.province)" :disabled="!edit">
                                        <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="16">
                                <el-form-item prop="city" style="border-bottom: 0;padding:0">
                                    <el-select v-model="userInfo.city" style="width:230px;margin-left:5px;" :disabled="!edit">
                                        <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="生日">
                            <el-date-picker
                                style="width: 270px;"
                                v-model="userInfo.birthday"
                                type="date"
                                :readonly="!edit"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                                </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary mt30" @click="submit" v-text="edit?'提交':'编辑'" style="margin-bottom: 35px;"></el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import Cutter from '@/components/avatar-cutter/avatar-cutter.vue'
import { UserCenterService } from '../../../service/userCenter.service'
import { Message } from 'element-ui'
const province = []
const city = []
export default {
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '基本信息',
                path: '/userCenter/userInfo'
            }],
            query: {
                name: '',
                phone: '',
                mail: '',
                address: '',
            },
            edit: false,
            imgSrc: 'https://api.goodyiyao.cn/static/upload/other/picture-avatar-03.png',
            showCutter: false, // 是否显示头像裁剪组件
            userInfo: {},
            province,
            city,
            fullscreenLoading: false,
            rules: {
                code_num:[
                    { required:true,message: '请输入验证码',trigger: 'blur' },
                    { min: 5, max: 5, message: '长度应为 5 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    components: {Bread,Cutter},
    watch: {
        province(newV) {
            this.province = newV
        },
        city(newV) {
            this.city = newV
        }
    },
    methods: {
        async uploadAvatar(src) {
            const blobToDataURL = (blob, callback) => {
                let a = new FileReader();
                a.onload = function (e) { callback(e.target.result); }
                a.readAsDataURL(blob);
            }
            blobToDataURL(src, base => {
                this.imgSrc = base;
            })
            this.fullscreenLoading = true;
            await UserCenterService.uploadHeadPic(src)
            Message.success('上传成功');
            this.showCutter = false
            this.fullscreenLoading = false;
        },
        async getList() {
            const data = await UserCenterService.getBaseInfo()
            this.userInfo = JSON.parse(JSON.stringify(data))
            this.imgSrc = JSON.parse(JSON.stringify(data.head_pic))
        },
        async getArea(level,id) {
            const data = await UserCenterService.getArea(level,id)
            switch( level ) {
                case 1:
                    this.userInfo.province = ''
                    this.province = data
                    this.userInfo.city = ''
                    break
                case 2: 
                    this.userInfo.city = ''
                    this.city = data
                    break
            }
        },
        async getAreaFirst(level,id) {
            const data = await UserCenterService.getArea(level,id)
            switch( level ) {
                case 1:
                    this.province = data
                    this.getAreaFirst(2,1)
                    break
                case 2: 
                    this.city = data
                    break
            }
        },
        async submit() {
            if(this.edit){
                await UserCenterService.saveUserInfo(this.userInfo)
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.edit = !this.edit
            }else{
                this.edit = !this.edit
            }
            
        }
    },
    async created() {
        await this.getList()
        this.getAreaFirst(1,0)
    }
}
</script>


<style lang="scss">
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 0 50px 30px;
            border: 1px solid #e3e2e1;
            display: flex;
        }
    }
    .p-user-data{
        display: flex;
        align-items: center;
        
    }
    .userInfo{
        .el-input{
            input[readonly] {
                border: none;
            }
        }
        .el-select{
            input[readonly] {
                border: 1px solid #B9B9B9;
            }
        }
      .contentWrap>.content{
          display: flex;
          text-align: center;
          .infoForm{
            display: flex;
            flex-wrap: wrap;
            width: 805px;
            text-align: left;
            .el-form-item{
                width: 370px;
                .mobileChange,.emailChange{
                    padding: 5px 10px;
                    background: #1d90d0;
                    color: #fff;
                    border-radius: 3px;
                    margin-left: 8px;
                }
            }
          }
        }
    }
</style>
<style lang="scss">
    .userInfo{
        .contentWrap>.content{
            padding: 0;
            .infoForm{
                display: flex;
                padding: 0;
                margin: 0;
                width: 100%;
                flex-direction: column;
                .el-form-item{
                    width: 100%;
                    border-bottom: 1px dashed #999;
                    padding-bottom: 15px;
                    .el-input__inner{
                        height: 32px!important;
                        line-height: 32px!important;
                    }
                    .el-input__inner[readonly]{
                        border: 0;
                    }
                    .el-select{
                        .el-input__inner[readonly]{
                            border: 1px solid #B9B9B9;
                        }
                        .el-input__inner[disabled]{
                            color: #606266;
                            background: #fff;
                            border: none;
                        }
                        .is-disabled{
                            .el-input__suffix{
                                display: none;
                            }
                        }
                    }
                }
                .el-col.disable{
                    width: 100px!important;
                    overflow: hidden;
                }
            } 
        }
    }
    
</style>